import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import CTAProvider from '../../containers/CTAProvider';
import ActionLink from './ActionLink';

const getCTALinkClassName = size =>
  classNames({
    'sl-forecast-cta-action-link': true,
    [`sl-forecast-cta-action-link--${size}`]: true,
  });

const ForecastCTAActionLink = ({ category, pageName, spotId, subregionId, ctaLocation, size }) => {
  const segmentProperties = {
    category,
    pageName,
    spotId,
    subregionId,
    ctaLocation,
    size,
  };

  return (
    <div className={getCTALinkClassName(size)}>
      <CTAProvider segmentProperties={segmentProperties}>
        <ActionLink />
      </CTAProvider>
    </div>
  );
};

ForecastCTAActionLink.propTypes = {
  category: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
  spotId: PropTypes.string.isRequired,
  ctaLocation: PropTypes.string.isRequired,
  subregionId: PropTypes.string,
  size: PropTypes.string,
};

ForecastCTAActionLink.defaultProps = {
  subregionId: null,
  size: 'small',
};

export default ForecastCTAActionLink;
